import { render, staticRenderFns } from "./mark_me.vue?vue&type=template&id=47a0e214&scoped=true"
import script from "./mark_me.vue?vue&type=script&lang=js"
export * from "./mark_me.vue?vue&type=script&lang=js"
import style0 from "./mark_me.vue?vue&type=style&index=0&id=47a0e214&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a0e214",
  null
  
)

export default component.exports